import React from 'react';
import GlobalStyle from '../styles/GlobalStyle';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Menu from '../components/Menu';
import LogOutView from '../components/LogOutView';
import { useOutlet } from 'react-router';
import { useUser } from '../context/UserContext';
import { Container, Wrapper, Tools, Tool } from '../styles/TableStyle';
import ReportDocsIcon from '../components/icons/ReportDocsIcon';
import { ProposalDocsIcon } from '../components/icons/ProposalDocsIcon';
import PublicationDocsIcon from '../components/icons/PublicationDocsIcon';
import AnnualReportIcon from '../components/icons/AnnualReportIcon';
import QuarterlyReportIcon from '../components/icons/QuarterlyReportIcon';
import StandardsPublish from './StandardsPublish';
import StandardsPublishIcon from '../components/icons/StandardsPublishIcon';


const ReportTools = () => {
    const outlet = useOutlet();
    const { roles } = useUser()
    return (
        <>
            <GlobalStyle />
            <AuthenticatedTemplate>
                <Container>
                    <div>
                        <Menu />
                    </div>
                    <Wrapper>
                        {outlet ? (
                            outlet
                        ) : (
                            <div>
                                <h1>Rapportgenerator</h1>
                                <Tools>
                                    <h4>Verktyg</h4>
                                    <div>
                                        {roles && roles.includes('Report') && (
                                            <>
                                                <Tool
                                                    to='/report-tools/proposal-report'
                                                >
                                                    <div>
                                                        <ProposalDocsIcon />
                                                        <span>Förslagslista</span>
                                                    </div>
                                                    <p>Lista förslag för fastställelse och upphävande av svensk standard</p>
                                                </Tool>
                                                <Tool
                                                    to={{
                                                        pathname: '/report-tools/publication-report'
                                                    }}
                                                >
                                                    <div>
                                                        <PublicationDocsIcon />
                                                        <span>Publiceringslista</span>
                                                    </div>
                                                    <p>Ny och upphävd svensk standard</p>
                                                </Tool>
                                                <Tool
                                                    to={{
                                                        pathname: '/report-tools/annual-report'
                                                    }}
                                                >
                                                    <div>
                                                        <AnnualReportIcon />
                                                        <span>Årsrapport</span>
                                                    </div>
                                                    <p>Fastställelse och utgivning</p>
                                                </Tool>
                                                <Tool
                                                    to={{
                                                        pathname: '/report-tools/quarterly-report'
                                                    }}
                                                >
                                                    <div>
                                                        <QuarterlyReportIcon />
                                                        <span>Sammanställning (kvartal)</span>
                                                    </div>
                                                    <p>Sammanställning av fastställda och upphävda standarder per korrespondens</p>
                                                </Tool>
                                                {/* 
                                                        <Tool
                                                            to={{
                                                                pathname: '/report-tools/standards-publish'
                                                            }}
                                                        >
                                                            <div>
                                                                <StandardsPublishIcon />
                                                                <span>Faställda standarder (Elsäkerhetsverket)</span>
                                                            </div>
                                                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p>
                                                        </Tool>
                                                    */}
                                            </>
                                        )}
                                    </div>
                                </Tools>
                            </div>
                        )}
                    </Wrapper>
                </Container>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LogOutView />
            </UnauthenticatedTemplate>
        </>
    )
}

export default ReportTools